import { Card, Group, Skeleton, Stack } from "@mantine/core";

/**
 * A skeleton shaped like what is coming.
 *
 * NO SPINNERS, anywhere, except inside a button that is submitting. A spinner
 * says "something is happening"; a skeleton says "a list of cards is
 * happening", which is the difference between a wait that feels broken and
 * one that feels short. It also stops the layout jumping when the data lands.
 */
export function LoadingSkeleton({
  variant = "card",
  count = 3,
}: {
  variant?: "card" | "list" | "table-row" | "detail";
  count?: number;
}) {
  if (variant === "table-row") {
    return (
      <Stack gap="xs">
        {Array.from({ length: count }, (_, i) => (
          <Group key={i} gap="md" wrap="nowrap">
            <Skeleton height={12} width="18%" radius="sm" />
            <Skeleton height={12} width="32%" radius="sm" />
            <Skeleton height={12} width="22%" radius="sm" />
            <Skeleton height={12} width="14%" radius="sm" />
          </Group>
        ))}
      </Stack>
    );
  }

  if (variant === "detail") {
    return (
      <Stack gap="lg">
        <Skeleton height={28} width="55%" radius="sm" />
        <Card withBorder radius="md" padding="lg">
          <Stack gap="sm">
            <Skeleton height={12} width="38%" radius="sm" />
            <Skeleton height={12} width="72%" radius="sm" />
            <Skeleton height={12} width="60%" radius="sm" />
          </Stack>
        </Card>
        <Card withBorder radius="md" padding="lg">
          <Stack gap="sm">
            <Skeleton height={12} width="45%" radius="sm" />
            <Skeleton height={12} width="82%" radius="sm" />
          </Stack>
        </Card>
      </Stack>
    );
  }

  if (variant === "list") {
    return (
      <Stack gap="sm">
        {Array.from({ length: count }, (_, i) => (
          <Group key={i} justify="space-between" wrap="nowrap">
            <Skeleton height={14} width="60%" radius="sm" />
            <Skeleton height={14} width="18%" radius="sm" />
          </Group>
        ))}
      </Stack>
    );
  }

  return (
    <Stack gap="md">
      {Array.from({ length: count }, (_, i) => (
        <Card key={i} withBorder radius="md" padding="md">
          <Stack gap="sm">
            <Skeleton height={16} width="58%" radius="sm" />
            <Skeleton height={12} width="40%" radius="sm" />
            <Group gap="xs">
              <Skeleton height={18} width={72} radius="sm" />
              <Skeleton height={18} width={56} radius="sm" />
            </Group>
          </Stack>
        </Card>
      ))}
    </Stack>
  );
}
